import { Grid } from "@material-ui/core"
import { ExportButton } from "./ExportButton"
import { useRevenueParams } from "../../hooks/useRevenueParams"
import { GcfView } from "./GCFView"
import { NonGCFView } from "./NonGCFView"

export type GcfContentType = {
  isGCF: boolean
}
export const DetailsContent = ({ isGCF }: GcfContentType) => {
  const { search } = useRevenueParams()

  const enrichedSearch = search + `&isGCF=${isGCF}`
  return (
    <>
      <Grid container justify="flex-end" alignItems="center">
        <div>
          <ExportButton search={search} type={isGCF ? "gcf" : "nonGCF"} />
        </div>
      </Grid>
      <div style={{ width: "100%", zIndex: 1 }}>
        {isGCF ? (
          <GcfView search={enrichedSearch} />
        ) : (
          <NonGCFView search={enrichedSearch} />
        )}
      </div>
    </>
  )
}
